/**
 * Authenticated app shell (spec 0006 §5.4, refreshed).
 *
 * Composes the fixed Sidebar (desktop) + Topbar (mobile hamburger
 * + breadcrumbs + search + user menu) and yields the page content
 * into a fluid main column.
 */
import { Outlet } from "react-router-dom";
import { CommandPaletteProvider } from "@/lib/command-palette-context";
import { CommandPalette } from "./CommandPalette";
import { PayoutHealthBanner } from "./PayoutHealthBanner";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function AppLayout() {
  return (
    // CommandPaletteProvider is scoped here (not at App root) so the
    // ⌘K shortcut + palette only mount for authenticated routes — auth
    // pages (Login / TOTP / change-password) don't get the global
    // keyboard binding. PR #136 review.
    <CommandPaletteProvider>
      <div className="flex min-h-screen bg-background">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="flex-1 px-4 py-6 sm:px-6 sm:py-8">
            <div className="mx-auto w-full max-w-7xl">
              <PayoutHealthBanner />
              <Outlet />
            </div>
          </main>
        </div>
        <CommandPalette />
      </div>
    </CommandPaletteProvider>
  );
}

export default AppLayout;
